import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Thông tin")
], -1)
const _hoisted_4 = { class: "button-group d-flex align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "card-body pl-9 pt-5 pb-0"
}
const _hoisted_6 = { class: "row pb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-1 fw-bold text-muted" }, "Tên:", -1)
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = {
  key: 0,
  class: "fw-bolder fs-6 text-dark"
}
const _hoisted_10 = { class: "row pb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-1 fw-bold text-muted" }, "Mã", -1)
const _hoisted_12 = { class: "col-4" }
const _hoisted_13 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_14 = { class: "row pb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-1 fw-bold text-muted" }, "Ngày tạo", -1)
const _hoisted_16 = { class: "col-3" }
const _hoisted_17 = {
  key: 0,
  class: "fw-bolder fs-6 text-dark"
}
const _hoisted_18 = {
  key: 0,
  class: "row pb-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-1 fw-bold text-muted" }, "Mô tả:", -1)
const _hoisted_20 = { class: "col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalThemVatTu = _resolveComponent("ModalThemVatTu")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_PerPageSelection = _resolveComponent("PerPageSelection")!
  const _component_DanhSachVatTuTable = _resolveComponent("DanhSachVatTuTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.danhMucVatTu)
      ? (_openBlock(), _createBlock(_component_ModalThemVatTu, {
          key: 0,
          "is-modal-open": _ctx.isModalOpen,
          "selected-vat-tu-items": _ctx.danhMucVatTu.vat_tu,
          "danh-muc-vat-tu-id": _ctx.danhMucVatTuId,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isModalOpen = false)),
          onAdded: _ctx.onAddedVatTuItems
        }, null, 8, ["is-modal-open", "selected-vat-tu-items", "danh-muc-vat-tu-id", "onAdded"]))
      : _createCommentVNode("", true),
    (_ctx.danhMucVatTu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.EDIT,
                "color-type": _ctx.ButtonTypeColors.SUCCESS,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.push(`/quan-ly/danh-muc-vat-tu/${_ctx.danhMucVatTuId}/cap-nhat`)))
              }, null, 8, ["button-type", "color-type"]),
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.BACK,
                "color-type": _ctx.ButtonTypeColors.PRIMARY,
                onClick: _ctx.goBack
              }, null, 8, ["button-type", "color-type", "onClick"])
            ])
          ]),
          (_ctx.danhMucVatTu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.danhMucVatTu)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.danhMucVatTu.ten_danh_muc), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.danhMucVatTu.ma_danh_muc), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.danhMucVatTu)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.moment(_ctx.danhMucVatTu.created_at).format('DD/MM/YYYY')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_component_DivRow, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DivCol, { cols: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Tài Khoản: ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DivCol, { cols: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_LabelCustom, {
                          "is-text-dark": true,
                          "is-bolder": true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.danhMucVatTu?.tk_ketoan.matk) + "/" + _toDisplayString(_ctx.danhMucVatTu?.tk_ketoan.mact ? _ctx.danhMucVatTu?.tk_ketoan.mact : '-') + " - " + _toDisplayString(_ctx.danhMucVatTu?.tk_ketoan.tentk), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.danhMucVatTu)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        (_ctx.danhMucVatTu)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: _ctx.danhMucVatTu.mo_ta,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.danhMucVatTu.mo_ta) = $event)),
                              type: "textarea",
                              disabled: "",
                              rows: 3
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.danhMucVatTu)
      ? (_openBlock(), _createBlock(_component_PageRowLayout, { key: 2 }, {
          "page-row-header": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.totalVatTuDisplay), 1)
          ]),
          "page-row-action-button": _withCtx(() => [
            _createVNode(_component_ButtonCustom, {
              "button-type": _ctx.ButtonsType.ADD,
              "color-type": _ctx.ButtonTypeColors.SUCCESS,
              onClick: _ctx.openModal
            }, null, 8, ["button-type", "color-type", "onClick"])
          ]),
          "page-row-content": _withCtx(() => [
            _createVNode(_component_PerPageSelection, {
              "per-page": _ctx.perPage,
              "per-page-arr": _ctx.perPageArr,
              onChange: _cache[3] || (_cache[3] = (value) => _ctx.perPage = value)
            }, null, 8, ["per-page", "per-page-arr"]),
            _createVNode(_component_DanhSachVatTuTable, {
              items: _ctx.vatTuItems,
              "cur-page": _ctx.currentPage,
              "per-page": _ctx.perPage
            }, null, 8, ["items", "cur-page", "per-page"]),
            (_ctx.vatTuItems.length > 0)
              ? (_openBlock(), _createBlock(_component_Pagination, {
                  key: 0,
                  page: _ctx.currentPage,
                  "page-size": _ctx.perPage,
                  total: _ctx.totalItems,
                  onChangePage: _cache[4] || (_cache[4] = (value) => _ctx.currentPage = value)
                }, null, 8, ["page", "page-size", "total"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}